import _extends from "@babel/runtime/helpers/esm/extends";
import { ProCard } from '@ant-design/pro-components';
import React from 'react';
export var SuperDashboardCard = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(ProCard, _extends({
    bordered: true,
    boxShadow: true,
    ref: ref
  }, properties), properties.children);
});
SuperDashboardCard.isProCard = true;